export type Position = {
  top: number;
  left: number;
};

type TeaserDetailParams = {
  iri: string | null;
  position: Position;
};

type State = {
  queue: TeaserDetailParams[];
};

export const state: State = {
  queue: [],
};
